import * as React from 'react';
import * as XLSX from 'xlsx';


export const xlsxExport = (props) => {
    const data = props?.data || [];

    // Create worksheet from JSON
    const ws = XLSX.utils.json_to_sheet(data);

    // Auto-adjust column widths
    const columnWidths = Object.keys(data[0] || {}).map((key) => {
        const maxLength = Math.max(
            key.length,
            ...data.map(row => (row[key] ? row[key].toString().length : 0))
        );
        return { wch: maxLength + 2 }; // `+2` for padding
    });
    ws['!cols'] = columnWidths;

    // Create workbook and append sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, props.sheetname ?? "Sheet1");

    // Write to file
    XLSX.writeFile(wb, `${props.filename ?? "Data"}.xlsx`);
};

const ExcelDownloader = (props) => {

    const handleExport = () => {
        xlsxExport(props);
    }


    return (
        <>
            <h6 onClick={handleExport}>Export as Xlsx</h6>
        </>
    );
}

export default ExcelDownloader